import { useNavigate } from "@tanstack/react-router";
import {
  type TransactionGroup,
  Transaction_Type,
  type UserBalance,
} from "schema/gen/es/chiikipoint/model/v2/model_pb";
import { css } from "../../../styled-system/css";
import Header from "../../components/header";
import { t } from "../../libs/i18n";
import { GrantTransactionDetail } from "./components/grant-transaction-detail";
import { PaymentTransactionDetail } from "./components/payment-transaction-detail";
import { PSInternalPaymentTransactionDetail } from "./components/psinternal-payment-transaction-detail";
import { RefundTransactionDetail } from "./components/refund-transaction-detail";
import { TransactionHeader } from "./components/transaction-header";
import { TransferInTransactionDetail } from "./components/transfer-in-transaction-detail";
import { TransferOutTransactionDetail } from "./components/transfer-out-transaction-detail";
import {
  getTransactionIconUrl,
  getTransactionName,
} from "./utils/transaction-helpers";

type TransactionDetailProps = {
  transactionGroup: TransactionGroup;
  type: Transaction_Type;
  balances: UserBalance[];
};

export function TransactionDetail({
  transactionGroup,
  type,
  balances,
}: TransactionDetailProps) {
  const summaryDetail = transactionGroup.transactionDetails[0];
  const store = summaryDetail.store;
  const navigate = useNavigate();

  const iconUrl = getTransactionIconUrl(store?.iconUrl, type);

  const onClickBack = () => {
    navigate({ to: "/transactions" });
  };

  return (
    <>
      <Header title={t("取引詳細")} onClickBack={onClickBack} />

      <div
        className={css({
          display: "flex",
          flexDirection: "column",
          gap: "16px",
          py: "32px",
          px: "16px",
        })}
      >
        <TransactionHeader
          transactionGroup={transactionGroup}
          iconUrl={iconUrl}
          title={getTransactionName(summaryDetail)}
          createdAt={Number(summaryDetail.transaction?.createdAt?.seconds)}
        />

        {(type === Transaction_Type.GRANT ||
          type === Transaction_Type.CHARGE) && (
          <GrantTransactionDetail
            transactionGroup={transactionGroup}
            balances={balances}
          />
        )}

        {type === Transaction_Type.TRANSFER_IN && (
          <TransferInTransactionDetail
            transactionGroup={transactionGroup}
            balances={balances}
          />
        )}

        {type === Transaction_Type.TRANSFER_OUT && (
          <TransferOutTransactionDetail transactionGroup={transactionGroup} />
        )}

        {type === Transaction_Type.PAYMENT && (
          <PaymentTransactionDetail transactionGroup={transactionGroup} />
        )}

        {type === Transaction_Type.PAYMENT_PSINTERNAL && (
          <PSInternalPaymentTransactionDetail
            transactionGroup={transactionGroup}
          />
        )}

        {type === Transaction_Type.REFUND && (
          <RefundTransactionDetail transactionGroup={transactionGroup} />
        )}
      </div>
    </>
  );
}
